import {
  ButtonGroupFormElement,
  ButtonGroupFormElementExecution,
} from "../../../../types";
import { TaskButtonGroupFormComponent } from "../../../task-types/form/wizard-form-elements/TaskButtonGroupFormComponent";

export const ButtonGroupInlineDisplay = ({
  ...props
}: {
  element: ButtonGroupFormElement;
  executionData?: ButtonGroupFormElementExecution;
}) => {
  return (
    <TaskButtonGroupFormComponent
      disabled
      onClick={() => {}}
      execution={props.element}
    />
  );
};
